import React, { useCallback, useMemo } from 'react';

import classNames from 'classnames';
import { debounce } from 'lodash';

interface InputProps
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  onDebounceChange?: (value: string) => void;
  className?: string | undefined;
}

const Input: React.FC<InputProps> = ({
  onDebounceChange = () => {},
  className = '',
  ...props
}: InputProps) => {
  const debounceHandler = useMemo(
    () =>
      debounce((value: string) => {
        onDebounceChange(value);
      }, 1000),
    [onDebounceChange]
  );

  const handleOnChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>): void => {
      const text = event.target.value;
      debounceHandler(text);
    },
    [debounceHandler]
  );

  return (
    <input
      {...props}
      className={classNames('input sm:flex-grow-0 flex-grow', className)}
      onChange={handleOnChange}
      data-testid="search"
      autoComplete="off"
    />
  );
};

export default Input;
